import { createSlice } from '@reduxjs/toolkit'

const initialState = {}

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  // reducers: {},
})

// export const { userLoggedIn, userLoggedOut } = userSlice.actions
export default settingsSlice.reducer
